// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1476":"c99ca0b0","6498":"17911e5d","6976":"c99ca0b0","7599":"c99ca0b0","9817":"c99ca0b0"}[chunkId] + ".chunk.css";
};